import { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import mapboxgl from 'mapbox-gl';
import { Toolbar } from '../map-search/toolbar';

export function Map({
  accessToken,

  isLoading,
  isNothing,

  bounds,
  markers,

  onMapInit,
  onViewportEvent,
  openFilters,
}) {
  let mapContainerRef = useRef();
  let isInited = useIsInited(isLoading);

  let className = classnames(`map-search__map`, {
    [`map-search__map_state_loading`]: isLoading,
    [`map-search__map_state_nothing`]: isNothing,
  });

  useEffect(() => {
    if (!isInited) return;

    mapboxgl.accessToken = accessToken;

    let map = new mapboxgl.Map({
      container: mapContainerRef.current,
      zoom: 13,
      maxZoom: 18,
      boxZoom: false,
      bounds,
      fitBoundsOptions: { padding: 64 }
    });

    onMapInit(map);
    map.on('moveend', onViewportEvent);

    return () => map.remove();
  }, [isInited]);

  return (
    <div className={className}>
      {isInited && (
        <>
          <div className={`map-search__container`} ref={mapContainerRef} />
          {markers}
        </>
      )}

      {!isLoading && isNothing ? (
        <div className={`map-search__nothing`}>
          <div className={`map-search__nothing-text`}>
            No listings found, try to adjust your filtering criteria.
          </div>
        </div>
      ) : null}

      {!isLoading && isNothing ? (
        <div className={`map-search__nothing`}>
          <div className={`map-search__nothing-text`}>
            No listings found, try to adjust your filtering criteria.
          </div>
        </div>
      ) : null}

      <Toolbar openFilters={openFilters} />
    </div>
  );
}

function useIsInited(isLoading) {
  let [isInited, setIsInited] = useState(false);

  useEffect(() => {
    if (isInited || isLoading) return;

    setIsInited(true);
  }, [isLoading]);

  return isInited;
}
